import api from '@/api';

import { Color } from './Colors.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/colors`;

export async function listColors() {
  const result = (await api.get(`${CONTROLLER_URL}`, null)) as unknown;

  return result as { data: Color[] };
}
